export default {
  en: {
    title: 'Random topic',
    topicLabel: 'Topic',
    subtopicLabel: 'Subtopic',
    spinTopicAria: 'Spin a new topic',
    spinSubtopicAria: 'Spin a new subtopic',
    startButton: 'Start conversation',
  },
  ru: {
    title: 'Случайная тема',
    topicLabel: 'Тема',
    subtopicLabel: 'Подтема',
    spinTopicAria: 'Крутить тему заново',
    spinSubtopicAria: 'Крутить подтему заново',
    startButton: 'Начать диалог',
  },
  de: {
    title: 'Zufälliges Thema',
    topicLabel: 'Thema',
    subtopicLabel: 'Unterthema',
    spinTopicAria: 'Neues Thema drehen',
    spinSubtopicAria: 'Neues Unterthema drehen',
    startButton: 'Dialog starten',
  },
  pt: {
    title: 'Tópico aleatório',
    topicLabel: 'Tópico',
    subtopicLabel: 'Subtópico',
    spinTopicAria: 'Sortear um novo tópico',
    spinSubtopicAria: 'Sortear um novo subtópico',
    startButton: 'Iniciar diálogo',
  },
  fr: {
    title: 'Sujet aléatoire',
    topicLabel: 'Sujet',
    subtopicLabel: 'Sous-sujet',
    spinTopicAria: 'Tirer un nouveau sujet',
    spinSubtopicAria: 'Tirer un nouveau sous-sujet',
    startButton: 'Lancer le dialogue',
  },
  es: {
    title: 'Tema aleatorio',
    topicLabel: 'Tema',
    subtopicLabel: 'Subtema',
    spinTopicAria: 'Sortear un nuevo tema',
    spinSubtopicAria: 'Sortear un nuevo subtema',
    startButton: 'Iniciar diálogo',
  },
};
